import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

type CopyAvailabilityPayload = {
  fromSemesterId: string
  toSemesterId: string
  usersIds: string[]
}

const useCopyAvailability = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: (payload: CopyAvailabilityPayload) =>
      httpService.panel.panelUsersBulkCopyAvailabilityCreate({
        from_semester_id: payload.fromSemesterId,
        to_semester_id: payload.toSemesterId,
        users_ids: payload.usersIds
      }),
    onSuccess,
    onError
  })

export default useCopyAvailability
